module.exports = __webpack_public_path__ + "static/media/default_image.2af2d9a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/default_image.jpg
// module id = ./src/statsradio/modules/tutorials/assets/default_image.jpg
// module chunks = 18